import modalVoyage from 'components/modal/modal-types/modal-voyage'
import modalImage from 'components/modal/modal-types/modal-image'
import modalPort from './modal-types/modal-port'

const modalContent = {
  async init(type: string, target: HTMLElement, extras) {
    return await this.render(target, await this.handle(type, extras))
  },
  async handle(type: string, extras) {
    const { id, line, mobileString, desktopString, culture, arUrl } = extras

    switch (type) {
      case 'port':
        return await modalPort.render({ id })
      case 'voyage':
        return modalVoyage.render({ id, line })
      case 'image':
        return modalImage.render({ mobileString, desktopString, culture, arUrl })
    }
  },
  render(target: HTMLElement, html: unknown) {
    target.innerHTML = ''
    target.insertAdjacentHTML('beforeend', html as string)
  },
}

export default modalContent
